module.exports = __webpack_public_path__ + "img/admin_adv_26.ac5080f9.png";